import React from "react";

export class WelcomePage extends React.Component{
    constructor(){
        super();
    }
    componentDidMount(){
        window.scrollTo(0, 0);
    }
    render(){
        return (
            <div className="welcome-page-container">
                <div className="welcome-splash-container">
                    <img src="./splash-image.png" className="welcome-splash-img"></img>
                </div>
                <div className="welcome-body-container">
                    <div className="welcome-left-align-container">
                        <h1 className="welcome-title-text">Pray Engine</h1>
                        <p className="welcome-content-text">The Command-Based Game Engine for <span className="important-text">NVL & ADV Games</span> (●'◡'●)</p>
                    </div>

                    <div className="welcome-cards-container">
                        <div className="welcome-card-container">
                            <div className="welcome-card-text-block">
                                <div className="welcome-card-text-wrapper">
                                    <span className="welcome-card-title-text">Create your game story without any effort</span>
                                    <span className="welcome-card-content-text">Command-Based Editor, using UI to create your game with commands.</span>
                                </div>
                            </div>
                            <div className="welcome-card-img-block">
                                <img src="./card-img-1.png" className="welcome-card-img"></img>
                            </div>
                        </div>
                        <div className="welcome-card-container">
                            <div className="welcome-card-img-block">
                                <img src="./card-img-2.png" className="welcome-card-img"></img>
                            </div>
                            <div className="welcome-card-text-block">
                                <div className="welcome-card-text-wrapper">
                                    <span className="welcome-card-title-text">Manage your project and assets easily</span>
                                    <span className="welcome-card-content-text">Preview and manage your game assets and settings.</span>
                                </div>
                            </div>
                        </div>
                        <div className="welcome-card-container">
                            <div className="welcome-card-text-block">
                                <div className="welcome-card-text-wrapper">
                                    <span className="welcome-card-title-text">Export your game to Desktop and Web</span>
                                    <span className="welcome-card-content-text">Test and Export your game to Web and Desktop(currently Windows supported) platforms.</span>
                                </div>
                            </div>
                            <div className="welcome-card-img-block">
                                <img src="./card-img-3.png" className="welcome-card-img"></img>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        )
    }
}